import type { ISettingValue } from "@bbj-types/setting";
import { PlainAutocomplete } from "@inputs/autocomplete/PlainAutocomplete";
import { coachingStageGetLabel, coachingStepsSortByStage } from "@root/utils/coachingSteps/autocomplete";
import { useCallback, useMemo } from "react";

export interface ICoacingStepFilterFormProps {
  value: ISettingValue[];
  setValue: (value: ISettingValue[]) => void;
  coachingSteps: ISettingValue[];
}

export const CoachingStepFilterForm = ({ value, setValue, coachingSteps }: ICoacingStepFilterFormProps) => {
  const options = useMemo(() => coachingSteps.toSorted(coachingStepsSortByStage), [coachingSteps]);

  const groupBy = useCallback((option: ISettingValue) => coachingStageGetLabel(option), []);
  const getOptionLabel = useCallback((option: ISettingValue) => option.label, []);
  const isOptionEqualToValue = useCallback(
    (option: ISettingValue, val: ISettingValue) => option.value === val.value,
    []
  );
  return (
    <PlainAutocomplete
      value={value}
      options={options}
      onChange={setValue}
      groupBy={groupBy}
      getOptionLabel={getOptionLabel}
      isOptionEqualToValue={isOptionEqualToValue}
      placeholder="Recherchez une étape..."
    />
  );
};
